enum NPCType {
  FAIRY = "FAIRY",
  VAMPRIE = "VAMPRIE",
  BUSINESSMAN = "BUSINESSMAN",
}

export default NPCType;
